import gql from "graphql-tag";
import { customerFragment } from '@/graphql/customer/customerFragments'
import { customerContactFragment } from '@/graphql/customer/customerContactFragments'
import { customerLocationFragment } from '@/graphql/customer/customerLocationFragments'

export const UPDATECUSTOMER = gql`
    mutation updateCustomer(
        $id: ID!
        $name: String
        $primary_phone: String
        $secondary_phone: String
        $fax: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $website: String
        $note: String
    ){
        updateCustomer(
            input: {
                id: $id
                name: $name
                primary_phone: $primary_phone
                secondary_phone: $secondary_phone
                fax: $fax
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                website: $website
                note: $note
            }
        ){
            ...customerFragment
        }
    }
    ${customerFragment}
`;
export const UPSERTCUSTOMER = gql`
    mutation upsertCustomer(
        $id: ID
        $name: String
        $primary_phone: String
        $secondary_phone: String
        $fax: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $website: String
        $note: String
        $internal_notes: String
    ){
        upsertCustomer(
            input: {
                id: $id
                name: $name
                primary_phone: $primary_phone
                secondary_phone: $secondary_phone
                fax: $fax
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                website: $website
                note: $note
                internal_notes: $internal_notes
            }
        ){
            ...customerFragment
            contacts {
                data {
                    ...customerContactFragment
                }
            }
            locations {
                data {
                    ...customerLocationFragment
                }
            }
        }
    }
    ${customerFragment}
    ${customerContactFragment}
    ${customerLocationFragment}
`;

export const DELETECUSTOMER = gql`
    mutation deleteCustomer(
        $id: ID!
    ){
        deleteCustomer(
            id: $id
        ){
            ...customerFragment
        }
    }
    ${customerFragment}
`

export const RESTORECUSTOMER = gql`
    mutation restoreCustomer(
        $id: ID!
    ){
        restoreCustomer(
            id: $id
        ){
            ...customerFragment
        }
    }
    ${customerFragment}
`

export const UPSERTCONTACT = gql`
    mutation upsertCustomerContact(
        $id: ID
        $name: String
        $title: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $primary_phone: String
        $secondary_phone: String
        $fax: String
        $website: String
        $email: String
        $note: String
        $customer_id: ID
    ){
        upsertCustomerContact(
            input: {
                id: $id
                name: $name
                title: $title
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                primary_phone: $primary_phone
                secondary_phone: $secondary_phone
                fax: $fax
                website: $website
                email: $email
                note: $note
                customer: {
                    connect : $customer_id
                }
            }
        ){
            ...customerContactFragment
            customer {
                ...customerFragment
            }
        }
    }
    ${customerContactFragment}
    ${customerFragment}
`;

export const DELETECONTACT = gql`
    mutation deleteCustomerContact(
        $id: ID!
    ){
        deleteCustomerContact(
            id: $id
        ){
            ...customerContactFragment
        }
    }
    ${customerContactFragment}
`

export const RESTORECONTACT = gql`
    mutation restoreCustomerContact(
        $id: ID!
    ){
        restoreCustomerContact(
            id: $id
        ){
            ...customerContactFragment
        }
    }
    ${customerContactFragment}
`

export const UPSERTLOCATION = gql`
    mutation upsertCustomerLocation(
        $id: ID
        $name: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $primary_phone: String
        $secondary_phone: String
        $fax: String
        $website: String
        $email: String
        $note: String
        $customer_id: ID
    ){
        upsertCustomerLocation(
            input: {
                id: $id
                name: $name
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                primary_phone: $primary_phone
                secondary_phone: $secondary_phone
                fax: $fax
                website: $website
                email: $email
                note: $note
                customer: {
                    connect : $customer_id
                }
            }
        ){
            ...customerLocationFragment
        }
    }
    ${customerLocationFragment}
`;

export const DELETELOCATION = gql`
    mutation deleteCustomerLocation(
        $id: ID!
    ){
        deleteCustomerLocation(
            id: $id
        ){
            ...customerLocationFragment
        }
    }
    ${customerLocationFragment}
`

export const RESTORELOCATION = gql`
    mutation restoreCustomerLocation(
        $id: ID!
    ){
        restoreCustomerLocation(
            id: $id
        ){
            ...customerLocationFragment
        }
    }
    ${customerLocationFragment}
`